export interface TabElement {
	key: string;
	label: string;
	isSelected: boolean;
}
